import { render, staticRenderFns } from "./SyncPointLms.vue?vue&type=template&id=856002ca&"
import script from "./SyncPointLms.vue?vue&type=script&lang=js&"
export * from "./SyncPointLms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports